/**
 * Roles the system treats as potentially SaaS users. Per S3DEV2-7500
 * (Jared Gailey 09/29), no other role is ever admin-elevated — which matches
 * transformUserRole (utils/misc.js:193-202), the only place the FE acts on
 * the flag today.
 */
export const SAAS_ELIGIBLE_ROLES = [
  "CompanyAdministrator",
  "OfficeAdministrator"
];

export const isSaasEligibleRole = role => SAAS_ELIGIBLE_ROLES.includes(role);

/**
 * Derives a user's SaaS status from the role and company currently selected
 * in the user form, matching the render-time company lookup idiom already
 * used by validateUserType (index.jsx:100).
 *
 * The result is display-only. It is never written into Formik values and is
 * never submitted — the backend derives S3_Employees.bAdminElevated from the
 * role and company on its own (S3DEV2-7500).
 */
export const deriveSaasFromCompany = (role, companyId, companies) => {
  if (!isSaasEligibleRole(role)) return false;
  if (!companyId) return false;
  const company = (companies || []).find(c => c.value === companyId);
  return !!(company && company.software_as_service);
};
